import { visitorIdentity } from "../visitorTraits";

const READY_POLL_MS = 1000;
const READY_MAX_TRIES = 15;

const call = (...args) => {
  try {
    window.clarity?.(...args);
  } catch {}
};

const isClarityReady = () =>
  typeof window.clarity === "function" && !window.clarity.q;

const whenClarityReady = (fn) => {
  if (isClarityReady()) {
    fn();
    return;
  }

  let tries = 0;
  const timer = setInterval(() => {
    tries += 1;

    if (isClarityReady()) {
      clearInterval(timer);
      fn();
    } else if (tries >= READY_MAX_TRIES) {
      clearInterval(timer);
    }
  }, READY_POLL_MS);
};

export const tagClarityVisitor = (visitor) => {
  const { visitorId, friendlyName, tags } = visitorIdentity(visitor);
  if (!visitorId) return;

  const apply = () => {
    call("identify", visitorId, null, null, friendlyName || visitorId);
    Object.entries(tags).forEach(([key, value]) => call("set", key, value));
  };

  apply();
  whenClarityReady(apply);
};

export const tagClarityEvent = (name) => call("event", name);

export default tagClarityVisitor;
